import { useFormContext, Controller } from "react-hook-form";
import PropTypes from "prop-types";
import NumberOnlyInput from "./FormInputs/NumberOnlyInput";
import { validateNPI } from "../ValidateFunctions"

FormNPIField.propTypes = {
  fieldName: PropTypes.string,
  focusedField: PropTypes.string,
  setFocusedField: PropTypes.func,
  fieldAttributes: PropTypes.object,
}

export default function FormNPIField({ fieldName, focusedField, setFocusedField, fieldAttributes }) {
  const { control } = useFormContext();

  return <Controller
      name={fieldName}
      control={control}
      rules={{
        validate: value => validateNPI(value)
      }}
      render={() => (
        <NumberOnlyInput
          fieldName={fieldName}
          focusedField={focusedField}
          setFocusedField={setFocusedField}
          fieldAttributes={fieldAttributes}
        />
      )}
    />
}